<template>
  <LayoutPrimary>
    <ModalTenantUserPrimary
      v-if="isViewingOwnPage"
      @update-tenant-user="updateTenantUser"
    />
    <router-view
      v-if="initialized"
      :key="$route.fullPath"
      :isViewingOwnPage="isViewingOwnPage"
      :tenantUser="tenantUser"
      :visitor="visitor"
    />
  </LayoutPrimary>
</template>

<script>
  import ApiTenantUser from '@js/api/tenant-user'
  import ApiTenantUserLink from '@js/api/tenant-user-link'
  import LayoutPrimary from '@modules/v2/layout/layout-primary'
  import ModalTenantUserPrimary from '@users/modals/modal-tenant-user-primary'
  import { mapState } from 'vuex'
  import { MODAL_WINDOW_NAMES } from '@js/constants'

  export default {
    name: 'UserRootView',
    components: {
      LayoutPrimary,
      ModalTenantUserPrimary,
    },
    data: function () {
      return {
        initialized: false,
        tenantUser: {},
        tenantUserId: null,
      };
    },
    created: async function () {
      this.tenantUserId = parseInt(this.$route.params?.id);
      if (
        this.tenantUserId === undefined ||
        this.tenantUserId === null
      ) {
        this.$router.push({
          name: 'private-home',
        });
      }

      await this.fetchTenantUser();
      this.initialized = await true;
    },
    computed: {
      ...mapState({
        visitor: state => state.tenantUser,
      }),
      isViewingOwnPage: function () {
        return this.visitor.id === this.tenantUser.id;
      },
    },
    methods: {
      fetchTenantUser: async function () {
        try {
          const api = await new ApiTenantUser(this.tenantUserId);
          const res = await api.get();
          this.tenantUser = await res.data;
        } catch (error) {
          console.error(error);
          this.$store.commit(
            'notification/setWarning',
            'Failed to load user data',
          );
          this.$router.push({
            name: 'private-home',
          });
        }
      },
      updateTenantUser: async function (form) {
        const payload = await form.getPutPayload();

        try {
          const api = await new ApiTenantUser(this.tenantUser.id);
          const res = await api.put(payload);
          this.tenantUser = await res.data;
        } catch (error) {
          console.error(error);
          this.$store.commit(
            'notification/setWarning',
            'Failed to update user profile',
          );
          this.$modal.hide(MODAL_WINDOW_NAMES.UPDATE_TENANT_USER_PRIMARY);
          return;
        }

        try {
          const api = await new ApiTenantUserLink(this.tenantUser.id);
          const res = await api.post(payload.links);
          this.tenantUser.links = await res.data;
        } catch (error) {
          console.error(error);
          this.$store.commit(
            'notification/setWarning',
            'Failed to update links',
          );
          this.$modal.hide(MODAL_WINDOW_NAMES.UPDATE_TENANT_USER_PRIMARY);
          return;
        }

        this.$store.commit(
          'notification/setMessage',
          'Updated user data',
        );
        this.$modal.hide(MODAL_WINDOW_NAMES.UPDATE_TENANT_USER_PRIMARY);
      },
    },
  };
</script>
